import { render, staticRenderFns } from "./payment-method-modal.vue?vue&type=template&id=2b0298a2&scoped=true&"
import script from "./payment-method-modal.vue?vue&type=script&lang=js&"
export * from "./payment-method-modal.vue?vue&type=script&lang=js&"
import style0 from "./payment-method-modal.vue?vue&type=style&index=0&id=2b0298a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0298a2",
  null
  
)

export default component.exports